import React from 'react';
import { AnimatedSection } from './AnimatedSection';
const locations = [{
  name: 'Thailand',
  x: '35%',
  y: '34%'
}, {
  name: 'Cambodia',
  x: '41%',
  y: '39%'
}, {
  name: 'Malaysia',
  x: '35%',
  y: '57%'
}, {
  name: 'Singapore',
  x: '36%',
  y: '62%'
}, {
  name: 'Philippines',
  x: '62%',
  y: '26%'
}];
export function SoutheastAsiaMap() {
  return <AnimatedSection data-id="element-170">
      <div className="flex flex-col items-center" data-id="element-171">
        <div className="relative w-full max-w-4xl mx-auto" data-id="element-172">
          {/* Background map SVG */}
          <img src="https://cdn.magicpatterns.com/uploads/rQHhv36Qw5q4mjt9LhSpz1/Group_394.svg" alt="Southeast Asia map" className="w-full h-auto" data-id="element-173" />

          {/* Location pins overlay */}
          {locations.map(loc => <div key={loc.name} className="absolute flex items-center gap-2" style={{
          left: loc.x,
          top: loc.y
        }} data-id="element-174">
              <div className="w-3 h-3 rounded-full bg-brand-red flex-shrink-0" data-id="element-175" />
              <span className="text-sm font-semibold text-brand-charcoal whitespace-nowrap" data-id="element-176">
                {loc.name}
              </span>
            </div>)}
        </div>
      </div>
    </AnimatedSection>;
}